/**
 * Create an object from given keys array and values array.
 * @param {Array<string>} keys
 * @param {Array<any>} values
 * @returns {object}
 */
export const objectFromArrays = <T>(keys: Array<string>, values: Array<T>): Record<string, T> => {
  let o = {};
  if (keys.length === values.length) keys.forEach((k: string, i: number) => (o = { ...o, [k]: values[i] }));
  return o;
};

/**
 * Get keys from object while preserving type information.
 * @param obj An object to get the keys from.
 * @returns An array of typed keys.
 */
export const getKeys = <T extends TAnyObject>(obj: T): Array<keyof T> => {
  return Object.keys(obj) as Array<keyof T>;
};

/**
 * Get all keys from object including nested keys.
 * @param obj An object to get the keys from.
 * @returns An array of all keys including nested keys (e.g., ["key1", "key2", "nestedKey"]).
 */
export const getNestedKeys = (obj: TAnyObject): Array<string> => {
  return Object.keys(obj).reduce((keys: Array<string>, key: string) => {
    const value = obj[key];

    if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
      return [...keys, key, ...getNestedKeys(value as TAnyObject)];
    }

    return [...keys, key];
  }, []);
};
